/** @jsx jsx */

import { Radio, RadioGroup, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { HelpBlockProps } from './HelpBlock';

type Props = {
  onSelect: () => void;
  option: HelpBlockProps;
  selected: boolean;
  value: string;
};

const Styles = {
  root: css`
    margin: 10px 0px 0px 0px;
  `,
  helpText: css`
    display: flex;
    margin-bottom: 10px;
  `,
};

const OptionBlock = ({ onSelect, option, value }: Props) => (
  <div css={Styles.root}>
    <RadioGroup onChange={onSelect} name={option.heading}>
      <Radio value={value}>
        <Text margin="0px 10px" tag="h4" type="Body4">
          {option.heading}
        </Text>
      </Radio>
    </RadioGroup>
    <div css={Styles.helpText}>
      <Text color="GrayWarm7" margin="8px 0px 0px 35px">
        {option.description}
      </Text>
    </div>
  </div>
);

export default OptionBlock;
